<app-loading [isLoading]="!progressService.selectedFestival()">
  <div class="flex flex-col gap-4 p-4">
    <h1 class="text-2xl leading-snug">Wonach möchten Sie Ihre Reservierung auswählen?</h1>
    <div class="grid md:grid-cols-2 grid-cols-1 gap-2">
      <button (click)="continueBooking('date')"
         class="text-left bg-white rounded-xl p-3 flex flex-col gap-2 border-2 border-benzGrey-900 hover:border-benzGrey-400">
        <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg"
             class="ml-1 mb-1">
          <path
            d="M5.33333 12.6667H8V15.3334H5.33333V12.6667ZM5.33333 18.0001H8V20.6667H5.33333V18.0001ZM10.6667 12.6667H13.3333V15.3334H10.6667V12.6667ZM10.6667 18.0001H13.3333V20.6667H10.6667V18.0001ZM16 12.6667H18.6667V15.3334H16V12.6667ZM16 18.0001H18.6667V20.6667H16V18.0001Z"
            fill="#B02B2C" />
          <path
            d="M2.66667 27.3334H21.3333C22.804 27.3334 24 26.1374 24 24.6667V6.00008C24 4.52941 22.804 3.33341 21.3333 3.33341H18.6667V0.666748H16V3.33341H8V0.666748H5.33333V3.33341H2.66667C1.196 3.33341 0 4.52941 0 6.00008V24.6667C0 26.1374 1.196 27.3334 2.66667 27.3334ZM21.3333 8.66675L21.3347 24.6667H2.66667V8.66675H21.3333Z"
            fill="#B02B2C" />
        </svg>

        <h2 class="font-bold">Datum</h2>
        <p>Ich möchte das {{ progressService.selectedFestival()?.title_public }} an einem bestimmten Tag besuchen.</p>
      </button>
      <button (click)="continueBooking('location')"
         class="text-left bg-white rounded-xl p-3 flex flex-col gap-2 border-2 border-benzGrey-900 hover:border-benzGrey-400">
        <svg width="22" height="28" viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg"
             class="ml-1 mb-1">
          <path
            d="M11 16.6667C13.9413 16.6667 16.3333 14.2747 16.3333 11.3334C16.3333 8.39208 13.9413 6.00008 11 6.00008C8.05867 6.00008 5.66667 8.39208 5.66667 11.3334C5.66667 14.2747 8.05867 16.6667 11 16.6667ZM11 8.66675C12.4707 8.66675 13.6667 9.86275 13.6667 11.3334C13.6667 12.8041 12.4707 14.0001 11 14.0001C9.52933 14.0001 8.33333 12.8041 8.33333 11.3334C8.33333 9.86275 9.52933 8.66675 11 8.66675Z"
            fill="#B02B2C" />
          <path
            d="M10.2267 27.0854C10.4524 27.2466 10.7227 27.3332 11 27.3332C11.2773 27.3332 11.5477 27.2466 11.7734 27.0854C12.1787 26.7987 21.7054 19.9201 21.6667 11.3334C21.6667 5.45208 16.8814 0.666748 11 0.666748C5.1187 0.666748 0.333369 5.45208 0.333369 11.3267C0.294703 19.9201 9.82137 26.7987 10.2267 27.0854ZM11 3.33341C15.412 3.33341 19 6.92142 19 11.3401C19.028 17.2574 13.1494 22.5707 11 24.3134C8.85204 22.5694 2.97204 17.2547 3.00004 11.3334C3.00004 6.92141 6.58804 3.33341 11 3.33341Z"
            fill="#B02B2C" />
        </svg>

        <h2 class="font-bold">Bereich im Zelt</h2>
        <p>Ich möchte beim {{ progressService.selectedFestival()?.title_public }} in einem bestimmten Bereich sitzen.</p>
      </button>
    </div>
  </div>
</app-loading>
